import {Axios} from '../axios/axios'
//司机列表 adminapi/getDriverList
export const getDriverList = (e) => {
  return Axios({
    url:"/adminapi/getDriverList",
    method:'POST',
    data:e
  })
}
//司机详情 adminapi/getDriverInfo
export const getDriverInfo = (e) => {
  return Axios({
    url:"/adminapi/getDriverInfo",
    method:'POST',
    data:e
  })
}

//新建司机 adminapi/addDriver
export const addDriver = (e) => {
  return Axios({
    url:"/adminapi/addDriver",
    method:'POST',
    data:e
  })
}
//编辑司机 adminapi/editDriver
export const editDriver = (e) => {
  return Axios({
    url:"/adminapi/editDriver",
    method:'POST',
    data:e
  })
}
//删除司机 adminapi/deleteDriver
export const deleteDriver = (e) => {
  return Axios({
    url:"/adminapi/deleteDriver",
    method:'POST',
    data:e
  })
}
//修改司机状态 adminapi/updateDriverStatus
export const updateDriverStatus = (e) => {
  return Axios({
    url:"/adminapi/updateDriverStatus",
    method:'POST',
    data:e
  })
}
